module.exports = __webpack_public_path__ + "static/img/testimony (46).a3fa10c2.jpg";